/**
 * Formatowanie i slowniki dla "Zamowienia z B2B" (panel admina, podglad zamowien z b2b.sfd.pl).
 * Kwoty/daty 1:1 z kontroli faktur (reuzycie). Etykiety statusow przychodza z backendu
 * (JEDEN slownik: backend/services/sfd_zamowienia_service.py ETYKIETY_*) - tu tylko kolory po kodzie.
 * Tylko tokeny kolorow var(--...) z v3sys-theme.css.
 */
import { dzisISO, dniWsteczISO, poczatekRokuISO } from '../kontrola-faktur/format';

export {
  formatujKwote, formatujDate, formatujDateCzas, dataISO, dzisISO, dniWsteczISO, poczatekRokuISO,
} from '../kontrola-faktur/format';

/** Portal zwraca 90 dni przed DateTo - tyle domyslnie pokazujemy. */
export const DOMYSLNE_DNI = 90;
/** "Caly czas": pelna historia z portalu (OD_HISTORII w serwisie backendu). */
export const OD_CALEJ_HISTORII = '2022-01-01';

export const SZYBKIE_ZAKRESY = [
  { id: '30', etykieta: '30 dni', od: () => dniWsteczISO(30) },
  { id: '90', etykieta: '90 dni', od: () => dniWsteczISO(DOMYSLNE_DNI) },
  { id: 'rok', etykieta: 'bieżący rok', od: () => poczatekRokuISO() },
  { id: 'wszystko', etykieta: 'cały czas', od: () => OD_CALEJ_HISTORII },
];
export const domyslnyZakres = () => ({ od: dniWsteczISO(DOMYSLNE_DNI), do: dzisISO() });

/** Ilosc: bez zbednych zer, przecinek polski; null -> '—'. */
export const formatujIlosc = (ilosc) => {
  if (ilosc === null || ilosc === undefined || ilosc === '' || Number.isNaN(Number(ilosc))) return '—';
  return Number(ilosc).toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
};

const NIEZNANY = { kolor: 'var(--text-secondary)', tlo: 'var(--bg)' };

/** Kolor statusu zamowienia po kodzie z listy portalu (-1 anulowane, 2/3/4 zrealizowane, reszta nieznana). */
export const kolorStatusu = (kod) => {
  if (kod === -1) return { kolor: 'var(--danger)', tlo: 'var(--danger-light)' };
  if (kod === 2 || kod === 3 || kod === 4) return { kolor: 'var(--success)', tlo: 'var(--success-light)' };
  return NIEZNANY;
};

/** Kolor statusu platnosci (0 niezaplacone, 1 zaplacone, 2 czesciowo). */
export const kolorPlatnosci = (kod) => {
  if (kod === 1) return { kolor: 'var(--success)', tlo: 'var(--success-light)' };
  if (kod === 2) return { kolor: 'var(--warning)', tlo: 'var(--warning-light)' };
  if (kod === 0) return { kolor: 'var(--danger)', tlo: 'var(--danger-light)' };
  return NIEZNANY;
};

/** Skrot tekstu do tabeli (pelny w tooltipie). */
export const skroc = (tekst, maks = 40) => {
  const t = String(tekst || '').trim();
  if (!t) return '';
  return t.length > maks ? `${t.slice(0, maks - 1).trimEnd()}…` : t;
};

/** Etykieta 'nieznanego adresu' - sklep_id=0 w filtrze listy. */
export const NIEZNANY_ADRES = 'nieznany adres';
export const SKLEP_NIEZNANY_ID = 0;

/** Komunikat bledu akcji - tresc z backendu (komunikat / message) ma pierwszenstwo. */
export const komunikatBledu = (err, domyslny = 'Nie udało się wykonać operacji.') => {
  if (err?.status === 409 || err?.errorCode === 'SYNC_W_TOKU') {
    return err?.data?.komunikat || 'Synchronizacja zamówień z SFD już trwa — poczekaj chwilę.';
  }
  if (err?.errorCode === 'SFD_BRAK_KONFIGURACJI') {
    return err?.data?.komunikat || 'Brak e-maila lub hasła do portalu SFD — uzupełnij w zakładce SFD B2B.';
  }
  if (err?.status === 403 || err?.isPermissionError) return 'Ta zakładka jest tylko dla administratora.';
  return err?.data?.komunikat || err?.data?.message || err?.message || domyslny;
};
